import apiClient from './apiClient';

const reminderService = {
  getReminders: (params) => apiClient.get('/reminders', { params }),
  getRemindersCount: () => apiClient.get('/reminders/count'),
};

export default reminderService;
